import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'

import * as mobileMenuActions from '../../actions/mobileMenu'

const MobileMenuTrigger = ({openMobileMenu}) => (
  <button className="c-mobile-menu-trigger" type="button" onClick={openMobileMenu}>
    <span className="u-sr-only">Open mobile menu</span>
    <span className="c-mobile-menu-trigger__hamburger">
      <span className="c-mobile-menu-trigger__bar" />
      <span className="c-mobile-menu-trigger__bar" />
      <span className="c-mobile-menu-trigger__bar" />
    </span>
  </button>
)

MobileMenuTrigger.propTypes = {
  openMobileMenu: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  openMobileMenu: mobileMenuActions.openMobileMenu,
}

export default connect(null, mapDispatchToProps)(MobileMenuTrigger)
